import type { User } from '@/types/auth'

/**
 * Determines the post-login redirect path based on user role
 *
 * Rules:
 * - CEO: /big-numbers (executive dashboard)
 * - Everyone else: /dashboard (standard dashboard)
 */
export function getPostLoginRedirect(user: User | null): string {
  if (!user) {
    return '/dashboard'
  }

  // CEO goes to big-numbers executive dashboard
  if (user.role === 'ceo') {
    return '/big-numbers'
  }

  // Everyone else goes to standard dashboard
  return '/dashboard'
}
